<script>
import { Doughnut } from 'vue-chartjs'
import chartDoughnutPlugin from './chartDoughnutPlugin'

export default {
    components: {
        Doughnut,
    },
    extends: Doughnut,
    props: {
        chartData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chartOptions: {
                responsive: true,
                legend: {
                    display: false,
                },
                tooltips: false,
                cutoutPercentage: 75,
                rotation: -1.5 * Math.PI,
            },
        }
    },
    mounted() {
        this.addPlugin(chartDoughnutPlugin)
        this.renderChart(this.chartData, this.chartOptions)
    },
    watch: {
        chartData: {
            handler() {
                this.renderChart(this.chartData, this.chartOptions)
            },
        },
    },
}
</script>
